export default "__VITE_ASSET__CpHE54FS__"